import Events from "~/ts/library/Events";
import {computed, ref} from "vue";

let isTouchedOnce = ref(false);

export const isTouchScreen = computed(() => {
    return isTouchedOnce.value || (window?.matchMedia ? !!window.matchMedia("(pointer: coarse)").matches : false);
});

Events.once("touchstart", document, () => {
    isTouchedOnce.value = true;
});